import { add, listen, qsa, toggle } from '@fluorescent/dom';

import { section } from '@/neon';

const slideshowOpts = {
  adaptiveHeight: false,
  draggable: false,
  fade: true,
  pageDots: false,
  prevNextButtons: false,
  wrapAround: true,
};

const classes = {
  active: 'is-active',
};

section('announcement-bar', {
  timer: null,

  onLoad() {
    const timing = parseInt(this.container.dataset.timing);
    const announcements = qsa('[data-single-announcement]', this.container);

    if (announcements.length > 1) {
      import('flickity').then(({ default: Flickity }) => {
        this.slideshow = new Flickity(this.container, {
          ...slideshowOpts,
          autoPlay: timing,
          on: {
            // Need to add a modifier to animate after the first slide has changed
            change(index) {
              announcements.forEach((el, i) => toggle(el, classes.active, index === i));
            },
          },
        });
        this.slideshow.on('pointerUp', () => this.handleRestart());
      });
    } else {
      add(announcements[0], "is-selected");
    };

    this.listeners = [listen(this.container, 'touchend', () => this.handleRestart())];
  },

  handleRestart() {
    clearTimeout(this.timer);
    this.timer = setTimeout(() => this.slideshow && this.slideshow.playPlayer(), 3500);
  },

  onBlockSelect({ target }) {
    this.slideshow && this.slideshow.pausePlayer();
    this.slideshow && this.slideshow.select(target.dataset.index);
  },

  onBlockDeselect() {
    this.slideshow && this.slideshow.unpausePlayer();
  },

  onUnload() {
    this.slideshow && this.slideshow.destroy();
    this.slideshow && this.listeners.forEach(l => l());
  },
});
